import styled from 'styled-components';

export const ProductCardListContainer = styled.div`
  width: 100%;

  .product-header {
    display: flex;
    width: 100%;
  }

  .offer-info {
    width: 100%;
    flex: 1;
    display: flex;
  }

  .validity-info {
    display: flex;
    flex: 0;
  }

  .producer-info {
    display: flex;
    flex: 1;
    text-align: left;
    text-align: left !important;

    .producer-label {
      text-align: left !important;
    }
  }

  .quality-info {
    display: flex;
    gap: 8px;
    flex: 1;
  }
`;

export const ProductCardListCard = styled.div`
  border: 1px solid #e8e8e8;
  padding: 16px;
  margin: 8px 0;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ProductImageSection = styled.div`
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductActionsSection = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 120px;
`;
